jQuery('.footer-block__item .content-wrapper').prepend('<div class="location"><img src="https://cdn.shopify.com/s/files/1/0738/7539/0679/files/location_svgrepo.com.png?v=1739958394"><p>Unit GC-11, Karma Stambh Industrial Estate, LBS Road, Vikhroli West, Mumbai – 400083</p></div>');
jQuery('.brands-block.brands-slider.brand_style_3 .halo-block-header').prepend('<h6 class="brand_head">OUR PROCESS</h6>');
jQuery('.brands-block.brands-slider.brand_style_3 .halo-block-header').append('<a class="brand_button" href="/pages/the-art-of-pickling-page">Read More</a>');
jQuery('.product-tab-block.product-block .container').prepend('<h6 class="sub_heading">LOREM IPSUM</h6>');
var descr = jQuery('.main_desc > .short_desc').html();
    jQuery('.short_desc').html(descr);
var descr = jQuery('.main_desc > .short_desc_2').html();
    jQuery('.short_desc_2').html(descr);
var descr = jQuery('.main_desc > .offer-text-main-lorem').html();
    jQuery('.offer-text-main-lorem').html(descr);
var descr = jQuery('.main_desc > .storage-instructions').html();
    jQuery('.storage-instructions').html(descr);
var descr = jQuery('.main_desc > .ingredient').html();
    jQuery('.ingredient').html(descr);
var descr = jQuery('.main_desc > .custom_short_desc').html();
    jQuery('.custom_short_desc').html(descr);
// var descr = jQuery('.main_desc > .faq_head1').html();
//     jQuery('.faq_head1').html(descr);
// var descr = jQuery('.main_desc > .faq_head2').html();
//     jQuery('.faq_head2').html(descr);
// var descr = jQuery('.main_desc > .faq_cont_2').html();
//     jQuery('.faq_cont_2').html(descr);
jQuery('.collections-wrapper.text-center h3.collection-title').append('<div class="collection_desc"></div>')
var short_desc = jQuery('.custom_short_desc').html();

jQuery('.t4s-product-form__variants').append(short_desc)
const accordionBtns = document.querySelectorAll(".accordion");

document.addEventListener('DOMContentLoaded', function() {
    var accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(function(item, index) {
      var header = item.querySelector('.accordion-header');
      var content = item.querySelector('.accordion-content');

      header.addEventListener('click', function() {
        // Close all items except the clicked one
        accordionItems.forEach(function(innerItem) {
          if (innerItem !== item) {
            innerItem.classList.remove('active');
            innerItem.querySelector('.plus-minus').textContent = '+';
            innerItem.querySelector('.accordion-content').style.display = 'none';
          }
        });

        // Toggle the active class
        item.classList.toggle('active');

        // Toggle the plus/minus symbol
        var symbol = header.querySelector('.plus-minus');
        symbol.textContent = item.classList.contains('active') ? '_' : '+';

        // Toggle the display of the content
        content.style.display = item.classList.contains('active') ? 'block' : 'none';
      });

      // Set the first item as active initially
      if (index === 0) {
        item.classList.add('active');
        content.style.display = 'block';
      }
    });
  });

    jQuery(".product-form__input legend.form__label").html(function(_, html) {
        return html.replace(/Packaging:/, '<strong>Packaging :</strong>');
    });
jQuery(".product-form__input legend.form__label").html(function(_, html) {
        return html.replace(/Size:/, '<strong>Size :</strong>');
    });

jQuery("label.form-label.quantity__label").html(function(_, html) {
        return html.replace(/Quantity:/, '<strong style="font-size:14px;">Quantity :</strong>');
    });

    jQuery(".productView-subtotal span.text").html(function(_, html) {
        return html.replace(/Subtotal: /, '<strong>Subtotal :</strong>');
    });

jQuery(".tab-content .toggle-title .text").html(function(_, html) {
        return html.replace(/PRODUCT DETAILS/, '<strong>PRODUCT DETAILS</strong>');
    });

jQuery(".tab-content .toggle-title .text").html(function(_, html) {
        return html.replace(/FAQs/, '<strong>FAQs</strong>');
    });

jQuery(".tab-content .toggle-title .text").html(function(_, html) {
        return html.replace(/ADDITIONAL INFORMATION/, '<strong>ADDITIONAL INFORMATION</strong>');
    });

jQuery(document).ready(function() {
    jQuery('.text.alertBox-message .time').hide(); // hide the span
    jQuery('.text.alertBox-message').contents().filter(function() {
        return this.nodeType === 3 && this.nodeValue.includes('minutes.');
    }).remove(); // remove the text node containing "minutes."
});
jQuery(document).ready(function() {
    jQuery('.template-404.page-width.page-margin.center p.page-desc').text('This page seems to have gone missing -Your selection might’ve rolled off the shelf or been snatched by a very hungry customer.Let’s get you back to something delicious:');
});
jQuery(document).ready(function() {
    jQuery('.template-404.page-width.page-margin.center h2.title').text('Uh-oh, we’re in a bit of a pickle.!');
});
jQuery('.footer-block__details').append('<img class="footer_icon" src="https://cdn.shopify.com/s/files/1/0738/7539/0679/files/Group_11685.png?v=1748332499">')

setTimeout(function () {
    var input = document.getElementById("NewsletterForm--Popup");
    if (input && input.placeholder) {
      let text = input.placeholder.trim();
      input.placeholder = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
  }, 1000);



